import React, { useEffect, useState } from 'react';
import { FrownOutlined, MehOutlined, SmileOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Image, Rate, Space, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router';

import Boton from '../Components/Atoms/Boton';
import '../Assets/Styles/pages/ConsultarRemisiones.css';
import clienteAxios from '../Utils/clienteAxios';
import ConsultarFirmas from '../Components/Organisms/ConsultaFirmas';
import { photosEndpoint } from '../Constants/apiEndpoint';
import buildPhotoUrl from '../Utils/buildPhotoUrl';
import TablaCompras from '../Components/Organisms/TablaCompras';
import { v4 as uuid } from 'uuid';

let srcFallbackImg =
  'data:image/png;base64,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';

const customIcons = {
  1: <FrownOutlined style={{ fontSize: '30px' }} />,
  2: <MehOutlined style={{ fontSize: '30px' }} />,
  3: <SmileOutlined style={{ fontSize: '30px' }} />
};
function ConsultarRemisiones() {
  let { idRutaDeEntrega, idRemision } = useParams();
  const [loading, setLoading] = useState(true);
  const [remision, setRemision] = useState([]);

  useEffect(() => {
    clienteAxios
      .get(`/rutas-de-entrega/${idRutaDeEntrega}/remision/${idRemision}`)
      .then((response) => {
        let data = response?.data?.data?.remision;

        let evidenceUrls = [];
        if (data?.evidence) {
          evidenceUrls = JSON.parse(data?.evidence).map((url) =>
            buildPhotoUrl(photosEndpoint, url)
          );
        }
        data.evidence = evidenceUrls;

        let details_orders = data?.pedidos.ordersProduct;
        details_orders = details_orders.map((order) => ({
          ...order,
          products: order?.productRemision
        }));
        data.details_orders = details_orders;

        setLoading(false);
        setRemision(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log('remision', remision);

  const navigate = useNavigate();
  const Imprimir = () => {
    window.print();
  };
  return (
    <Spin spinning={loading} tip="Cargando...">
      <div id="my-section">
        <h1>
          <ArrowLeftOutlined style={{ fontSize: '2rem' }} onClick={() => navigate(-1)} />
          remisión de entrega - {remision?.code_remission}
        </h1>

        <h2 className="mt-5">productos afectados</h2>
        <TablaCompras
          data={remision?.details_orders}
          tableType="all"
          buttonsColumn={false}
          expectedDeliveredQuantityColumn={true}
        />

        <h2 className="mb-4 mt-4">Retroalimentación del cliente</h2>

        <div className="flex justify-content-around mb-4">
          <div>
            <span className="font-weight-500">Comentarios: </span>
            <span>{remision?.comments}</span>
          </div>

          <div>
            <span className="font-weight-500">Calificación: </span>
            <Rate
              className="ml-1"
              character={({ index }) => customIcons[index + 1]}
              style={{ color: '#1677ff' }}
              value={remision?.satisfaction}
              disabled
            />
          </div>
        </div>

        <div className="flex justify-content-around ">
          <div className="text-align-center">
            <span className="font-weight-500">Evidencia:</span>
          </div>
        </div>

        <div style={{ overflowX: 'auto', maxHeight: '400px' }} className="mb-4">
          <Space key={uuid} size="small">
            {remision?.evidence?.map((evidenceUrl, index) => (
              <Image
                width={200}
                src={evidenceUrl}
                fallback={srcFallbackImg}
                className="rounded"
                key={index}
              />
            ))}
          </Space>
        </div>

        <ConsultarFirmas
          nombreElaboro={remision?.delivered}
          nombreReviso={remision?.received}
          firmaElaboro={remision?.delivery_signature}
          firmaReviso={remision?.signature_received}
          type="remision"
        />

        <div className="justify-content-end mt-4">
          <Boton type="primary" onClick={Imprimir}>
            Descargar Remisión
          </Boton>
        </div>
      </div>
    </Spin>
  );
}

export default ConsultarRemisiones;
